
import React from 'react';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero">

      <div className="hero-overlay">

        <div className="hero-content">

          <div className="hero-text">

            <p className="hero-small-text">
              PROFESSIONAL MOBILE CLEANING SERVICES
            </p>

            <h1>
              Clean Cars.
              <br />
              Clean Homes.
              <br />
              Better Living.
            </h1>

            <p className="hero-description">
              Professional mobile car wash and house cleaning services
              delivered directly to your location in Cape Town.
            </p>

            <div className="hero-buttons">
            <a href="mailto:info@reasonableservices.co.za" 
             className="email-book-btn" > Request A Free Quote </a>
             

              <a
                href="https://wa.me/27767201554"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
               Request A Booking
              </a>

            </div>

            <div className="hero-features">

              <div className="feature-card">
                <h3>🚗Mobile Services</h3>
                <p>We Come To You</p>
              </div>

              <div className="feature-card">
                <h3>⭐Trusted Services</h3>
                <p>5-Star Customer Satisfaction</p>
              </div>

              <div className="feature-card">
                <h3>📍Cape Town,Southern Suburbs Coverage</h3>
                <p>Homes, Airbnb and Vehicles</p>
              </div>

               <div className="feature-card">
                <h3>⚡Fast Response</h3>
                <p>Same-Day Availability</p>
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
}

export default HeroSection;


